import {
	// walterApi,
	classificacaoSitioApi,
	registryApi,
	treeviaGateway,
} from '../clients/AxiosClients'
// import allClassificaoSitio from "../responses/classificacaoSitio/allClassificacaoSitio.json"
import parcelasFiltradas from '../responses/classificacaoSitio/parcelasFiltradas.json'
// import bodyModelChosen from "./mock/ParcelasHistograma.json"

/**
 *
 * @returns Classificação de Sítio dado o seu Id
 */
const getClassificacaoPorId = async (id) => {
	return registryApi.get(`v1/ClassificacaoSitio/GetClassificacaoById?id=${id}`)
}

/**
 *
 * @returns dados do planejamento de uma classificação dado seu Id
 */
const getPlanejamentoClassificacao = async (id) => {
	return treeviaGateway.get(
		`/ms-classificacaodesitio/classificacaodesitio/buscar-classificacao-de-sitio/${id}`,
	)
}

/**
 * Retorna todos classificações de sítio cadastradas no banco de dados para popular a grid
 */
const getAllClassificacaoSitio = async () => {
	// return registryApi.get('/ClassificacaoSitio')
	// return allClassificaoSitio;
	return treeviaGateway.get('/ms-classificacaodesitio/classificacaodesitio/listar')
}

/**
 * Cadastrar nova classificação de sítio no banco de dados
 * @param {Object} body Classificação de Sítio que será cadastrada
 */
const createClassificacaoSitio = async (body) => {
	return treeviaGateway.post('/ms-classificacaodesitio/classificacaodesitio/cadastrar', body)
}

/**
 * Busca parametros de uma classificação de sítio dado um id
 * @param {uuid} id Id da classificação em que se deseja buscar os parametros
 */
const getParametrosById = async (id) => {
	return treeviaGateway.get(
		`/ms-classificacaodesitio/classificacaodesitio/buscar-parametrizacoes/${id}`,
	)
}

/**
 * Atualiza Classificação de Sítio no banco de dados
 * @param {Object} body Classificação de Sítio que será atualizada
 */
const updateClassificacaoSitio = async (body) => {
	return treeviaGateway.put(
		'/ms-classificacaodesitio/classificacaodesitio/editar-classificacao-de-sitio',
		body,
	)
}

/**
 * Lista dos ids de Classificação de Sítio que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Classificação de Sítio
 */
const deleteClassificacaoSitioByIdList = async (data) => {
	// return registryApi.delete('/ClassificacaoSitio/DeleteByIdList', { data })
	return treeviaGateway.delete('/ms-classificacaodesitio/classificacaodesitio/excluir', { data })
}

export const recuperarInformacoesHistoricasParaDropdows = async () => {
	return treeviaGateway.get(
		'/ms-prognoses/FiltroMedicaoHistorica/recuperar-informacoes-para-dropdowns',
	)
}

/**
 *
 * @param {Object} filtros Várias listas de filtros
 *
 * Filtros inicialmente suportados:
 *
 * • Lista de Estratos
 * • Lista de Data de Plantio
 * • Lista de Idade do Plantio
 * • Lista de Material Genético
 * • Lista de Espécie
 * • Lista de Data de Medição
 * • Lista de Fazenda
 * • Lista de Espaçamento
 * • Lista de Variável Customizadas
 * • Tipo de Serviço (IFI, IFC, IPC)
 */

const filtraParcelas = async () => {
	return parcelasFiltradas
}

const especiesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/especies')
}

const materialGeneticoDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/material-genetico')
}

const idadePlantioDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/idade-plantio')
}

const fazendasDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/fazendas')
}

const espacamentosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/espacamentos')
}

const estratosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/estratos')
}

const talhoesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/talhoes')
}
const plantiosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/plantios')
}
const parcelasDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/parcelas')
}
const cidadesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/cidades')
}
const paisesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/paises')
}
const manejosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/manejos')
}
const ciclosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/ciclos')
}
const rotacoesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/rotacoes')
}

const variaveisDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/variaveis')
}

const buscarConfigsClassificaoById = async (id) => {
	return registryApi.get(`/configuracoes-classificacao/${id}`)
}

const getFiltrosDropdown = async () => {
	//const { data: dataPlantio } = await dataPlantioDropdown();
	const { data: especies } = await especiesDropdown()
	const { data: materialGenetico } = await materialGeneticoDropdown()
	const { data: idadePlantio } = await idadePlantioDropdown()
	const { data: fazendas } = await fazendasDropdown()
	const { data: espacamentos } = await espacamentosDropdown()
	const { data: estratos } = await estratosDropdown()
	//const { data: datasMedicao } = await dataMedicaoDropdown();
	const { data: talhoes } = await talhoesDropdown()
	const { data: plantios } = await plantiosDropdown()
	const { data: parcelas } = await parcelasDropdown()
	const { data: cidades } = await cidadesDropdown()
	const { data: paises } = await paisesDropdown()
	const { data: manejos } = await manejosDropdown()
	const { data: ciclos } = await ciclosDropdown()
	const { data: rotacoes } = await rotacoesDropdown()
	const { data: variaveis } = await variaveisDropdown()

	return {
		//datasPlantio: dataPlantio.result.map(d => { return { ...d, label: d.descricao } }),
		especies: especies.result.map((d) => {
			return { ...d, label: `${d.codigo ?? ''} - ${d.descricao ?? ''}` }
		}),
		materiaisGeneticos: materialGenetico.result.map((d) => {
			return { value: d.id, label: `${d.codigo ?? ''} - ${d.descricao ?? ''}` }
		}),
		idadesPlantio: idadePlantio.result.map((d) => {
			return { ...d, label: d.idade }
		}),
		fazendas: fazendas.result,
		espacamentos: espacamentos.result.map((d) => {
			return { ...d, label: d.descricao }
		}),
		estratos: estratos.result,
		// datasMedicao: datasMedicao.result.map(d => { return { ...d, label: d.descricao } }),
		talhoes: talhoes.result.map((d) => {
			return { ...d, label: d.codigo }
		}),
		plantios: plantios.result.map((d) => {
			return { ...d, label: d.codigo }
		}),
		parcelas: parcelas.result.map((d) => {
			return { ...d, label: d.codigo }
		}),
		cidades: cidades.result.map((d) => {
			return { ...d, label: d.cidade }
		}),
		paises: paises.result.map((d) => {
			return { ...d, label: d.pais }
		}),
		manejos: manejos.result
			.map((d) => {
				return { ...d, label: d.manejo }
			})
			.filter((f) => f.manejo),
		ciclos: ciclos.result
			.map((d) => {
				return { ...d, label: d.ciclo }
			})
			.filter((f) => f.ciclo),
		rotacoes: rotacoes.result
			.map((d) => {
				return { ...d, label: d.rotacao }
			})
			.filter((f) => f.rotacao),
		variaveis: variaveis.result,
	}
}

const filterParcelas = async (params) => {
	return registryApi.post('v1/filtrocategoriaprognose/filtro-para-classificacao-de-sitio', params)
}

const sendProcessamento = async (body) => {
	// return walterApi.post("/SiteClassificationModelAdjustment/SiteClassificationModels", { parcelas: body })
	return classificacaoSitioApi.post('/classificacaodesitiomodelos/gerar-modelos', body)
}

const chooseModel = async (body) => {
	// body = bodyModelChosen;
	// return walterApi.post("/SiteClassificationModelAdjustment/SiteClassificationDefaultMethods", body)
	return classificacaoSitioApi.post('/classificacaodesitiomodelos/classificar-padrao', body)
}

const classificarSitio = async (body) => {
	// body = bodyModelChosen;
	// return walterApi.post("/SiteClassificationModelAdjustment/SiteClassificationMethods", body)
	return classificacaoSitioApi.post('/classificacaodesitiomodelos/classificar-customizado', body)
}

const salvarPlanejamento = async (body) => {
	return treeviaGateway.post(
		'/ms-classificacaodesitio/classificacaodesitio/salvar-dados-de-modelo-escolhido',
		body,
	)
}

export {
	chooseModel,
	buscarConfigsClassificaoById,
	classificarSitio,
	createClassificacaoSitio,
	deleteClassificacaoSitioByIdList,
	filterParcelas,
	filtraParcelas,
	getAllClassificacaoSitio,
	getClassificacaoPorId,
	getFiltrosDropdown,
	getParametrosById,
	getPlanejamentoClassificacao,
	salvarPlanejamento,
	sendProcessamento,
	updateClassificacaoSitio,
}
